import { render, staticRenderFns } from "./AlertNotificationModal.vue?vue&type=template&id=b437b7ea&scoped=true&"
import script from "./AlertNotificationModal.vue?vue&type=script&lang=ts&"
export * from "./AlertNotificationModal.vue?vue&type=script&lang=ts&"
import style0 from "./AlertNotificationModal.vue?vue&type=style&index=0&id=b437b7ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b437b7ea",
  null
  
)

export default component.exports